import React, { useState, useEffect } from 'react';
import { RouterProvider } from "react-router-dom";
import { router } from './routes';
import ScrollToTop from "react-scroll-to-top";
import Loading from "./components/loading/loading"

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); 
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loading-container">
          <Loading></Loading>
        </div>
      ) : (
        <RouterProvider router={router} />
      )}
      <ScrollToTop smooth color="#4E6844" className='scroll-to-top' />
    </div>
  );
};

export default App;
